// Returns the names of every accessControl flag that is true and ends with the given suffix
// e.g. ({ budgetControlAccess: true, foo: true }, 'Access') => ['budgetControlAccess']
const getActiveScopes = (accessControl = {}, suffix) => Object.keys(accessControl)
  .filter((key) => key.endsWith(suffix) && accessControl[key] === true);

// Helper function to check if an item should be included based on roleScopes
//   ...Only   flags: user sees ONLY items listing a matching scope (defaults are NOT included)
//   ...Access flags: user sees the default items PLUS items listing a matching scope
const shouldIncludeItem = (item, user, accessControl) => {
  if (!item.enabled || (!item.route && item.scope === 'view')) return false;

  const roleScopes = item.roleScopes || [];

  // Admin can see everything with '' (standard access) or 'adminOnly'
  if (user.access === 'admin') {
    return true;
  }

  // Any "...Only" flag (e.g. selfServiceOnly) restricts the user to items with a matching scope.
  // Multiple flags are a union: matching any one of them is enough.
  const onlyScopes = getActiveScopes(accessControl, 'Only');
  if (onlyScopes.length > 0) {
    return onlyScopes.some((scope) => roleScopes.includes(scope));
  }

  // Any "...Access" flag (e.g. budgetControlAccess) adds items on top of the standard items.
  const isStandardItem = roleScopes.length === 0 || roleScopes.includes('');
  const accessScopes = getActiveScopes(accessControl, 'Access');
  if (accessScopes.length > 0) {
    return isStandardItem || accessScopes.some((scope) => roleScopes.includes(scope));
  }

  // Otherwise, show all standard access items ('' or empty array)
  return isStandardItem;
};

export default shouldIncludeItem;
